export default {
  areaName: {
    ar: "اسم المنطقة",
    en: "Area name"
  },
  deletePopup: {
    ar: "هل انت متأكد من انك تريد حذف هذه البلد ؟",
    en: "Are you sure you want to delete this country ?"
  }
}